import React, { useEffect, useState } from "react";
import { getEvents } from "../Service/Api"; 
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
const Events = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const monthNames = [
      "Jan","Feb","Mar", "Apr", "May", "Jun", "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    useEffect(() => {
      const fetchData = async () => {
        try {
          const eventData = await getEvents();
          const validEvents = eventData.filter(
            (item) => typeof item.title === "string" && item.title.trim().length > 0
          );
          const sortedEvents = [...validEvents].sort(
            (a, b) => new Date(b.date) - new Date(a.date)
          );
          const only4enty = sortedEvents.slice(0, 4);
          setData(only4enty);
        } catch (error) {
          setError(error);
        } finally {
          setLoading(false);
        }
      };
      fetchData();
    }, []);
  return (
    <>
      <div className="eventsec">
        <div className="border-blk">
          <h3>
            Upcoming Events{" "}
            <Link to="/upcoming-events">
              <i className="bi bi-chevron-double-right"></i>
            </Link>
          </h3>
          <div className="row">
            {data && data.length > 0 ? (
              data.map((item) => {
                const date = new Date(item.date);
                const mon = monthNames[date.getMonth()];
                const eventdate = date.getDate();

                return (
                  <div className="col-lg-6 col-md-6" key={item._id || item.id || item.date}>
                    <div className="row">
                      <div className="col-xl-7 col-lg-6 col-md-6">
                        <LazyLoad>
                          {item.images && item.images.length > 0 ? (
                            <a
                              data-magnify="gallery"
                              data-src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.images}`}
                              data-group="a"
                              href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.images}`}
                            >
                              <img
                                src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.images}`}
                                alt="Gallery"
                                className="img-fluid eventimg"
                              />
                            </a>
                          ) : (
                            <img
                              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/events.jpg"
                              className="img-fluid eventimg"
                              alt="SPCSH"
                            />
                          )}
                        </LazyLoad>
                      </div>
                      <div className="col-xl-5 col-lg-6 col-md-6">
                        <div className="eventdesc">
                          <p>
                            <LazyLoad>
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/calicn.png"
                                className="img-fluid"
                                alt="SPCSH"
                              />
                            </LazyLoad>{" "}
                            {eventdate} {mon}
                          </p>
                          <p>
                            <LazyLoad>
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/timeicn.png"
                                className="img-fluid"
                                alt="SPCSH"
                              />
                            </LazyLoad>{" "}
                            {item.time}
                          </p>
                          <p>
                            <LazyLoad>
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/locicn.png"
                                className="img-fluid"
                                alt="SPCSH"
                              />
                            </LazyLoad>{" "}
                            {item.venue}
                          </p>
                        </div>
                      </div>
                      <h5>{item.title}</h5>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="col-lg-6 col-md-6">
                <div className="row h-100 align-items-center">
                  <div className="col-12">
                    <div className="eventdesc text-center py-5">
                      <h5>No event is available</h5>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default Events
